import React, { lazy, Suspense } from "react";
import { FaCheck } from "react-icons/fa6";
import { Helmet } from "react-helmet-async";
import HeadImageApp1 from "@/assets/citywise/waggex-payroll-software-noida-hero-all-in-one.webp";
import HeadImageAppMobile from "@/assets/citywise/waggex-payroll-software-mohali-hero-section.webp?w=1150&format=webp";

const Whywaggexcommonchoice = lazy(
  () => import("./common/Whywaggexcommonchoice"),
);
const LookingforPayroll = lazy(() => import("./common/LookingforPayroll"));
const HomeFaq = lazy(() => import("../../pages/HomeFaq"));
const AppDownloadCard = lazy(() => import("../common/AppDownloadCard"));
const PayrollBanner = lazy(() => import("../common/PayrollBanner"));
const ModernizeHR = lazy(() => import("../common/ModernizeHR"));

const Mohali = () => {
  const faq1 = [
    {
      title: "How can payroll software help growing businesses?",
      content:
        "Payroll software automates salary calculations, attendance, leave management, statutory deductions, and payslip generation. It reduces manual work, improves payroll accuracy, and helps HR teams process payroll more efficiently every month.",
    },
    {
      title: "Can payroll, attendance, and leave management work together?",
      content:
        "Yes. Attendance, approved leave, overtime, and shift data are automatically linked to payroll, ensuring accurate salary calculations without maintaining separate spreadsheets or manual records.",
    },
    {
      title:
        "Is the software suitable for startups, SMEs, and large businesses?",
      content:
        "Absolutely. The platform is designed for startups, SMEs, manufacturing units, IT companies, retail businesses, service organizations, and enterprises managing different workforce sizes and structures.",
    },
  ];

  const faq2 = [
    {
      title:
        "Can employees access payslips and manage HR tasks from their phones?",
      content:
        "Yes. Employees can mark attendance, apply for leave, download payslips, view attendance history, and receive company updates through the Staff App, reducing routine HR requests.",
    },
    {
      title: "Does the software support AI attendance and GPS tracking?",
      content:
        "Yes. The platform supports AI face recognition, GPS attendance, geo-fencing, and selfie-based check-ins, helping businesses improve attendance accuracy, prevent buddy punching, and simplify payroll processing.",
    },
  ];
  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",

      name: "Waggex",

      url: "https://www.waggex.com/best-payroll-software-in-mohali",

      image: "https://www.waggex.com/waggex-payroll-software-logo.png",

      description:
        "Best payroll software in Mohali for businesses and SMEs. Streamline payroll processing, attendance tracking, leave management, employee records, and workforce management.",

      applicationCategory: "BusinessApplication",

      operatingSystem: "Web, Android, iOS",

      featureList: [
        "Payroll software Mohali",
        "Attendance management software Mohali",
        "Leave and shift management Mohali",
        "Face recognition attendance Mohali",
        "Employee self-service app",
        "GPS attendance tracking",
        "Automated payroll processing",
        "AI selfie attendance",
      ],

      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "INR",
        description: "Free trial available",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.8",
        ratingCount: "250",
        bestRating: "5",
        worstRating: "1",
      },
      provider: {
        "@type": "Organization",
        name: "Waggex",
        url: "https://www.waggex.com",
        logo: "https://www.waggex.com/waggex-payroll-software-logo.png",

        areaServed: {
          "@type": "Country",
          name: "India",
        },

        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+91-01724534553",
          email: "Info@waggex.com",
          contactType: "customer support",
        },
      },
    },

    {
      "@context": "https://schema.org",
      "@type": "FAQPage",

      mainEntity: [
        {
          "@type": "Question",
          name: "Which is the best payroll software in Mohali?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The best payroll software depends on your business requirements. Waggex helps Mohali businesses automate payroll, attendance management, leave tracking, and payslip generation from one connected platform.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex support attendance-based payroll?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex links employee attendance, approved leave, and working hours directly to payroll, so salaries are calculated accurately without manual cross-checking.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex provide mobile attendance?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Employees can mark attendance through the Waggex Staff App using selfie or GPS-based check-ins, suitable for office staff, IT teams, and field employees.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex support face recognition attendance?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex offers AI-powered face recognition attendance via the FaceLens app for secure, contactless employee verification without any additional hardware.",
          },
        },
      ],
    },

    {
      "@context": "https://schema.org",
      "@type": "Organization",

      name: "Waggex",

      url: "https://www.waggex.com/",

      logo: "https://www.waggex.com/waggex-payroll-software-logo.png",

      description:
        "Waggex provides payroll and HRMS software for businesses in Mohali and across India.",

      areaServed: "IN",

      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        availableLanguage: ["English", "Hindi", "Punjabi"],
      },
    },

    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",

      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.waggex.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Payroll Software Mohali",
          item: "https://www.waggex.com/best-payroll-software-in-mohali",
        },
      ],
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Payroll Software in Mohali | Manage HR, Salary & Attendance
        </title>
        <meta
          name="description"
          content="Run accurate payroll for your Mohali business with Waggex. Manage salaries, attendance, leave, employee data, and compliance from one secure HRMS platform"
        />
        <meta
          name="keywords"
          content="payroll software in Mohali,payroll software Mohali,HR software for businesses in Mohali,,attendance management software Mohali,HRMS software Mohali,online payroll system Mohali,employee management software Mohali,leave management software Mohali,face recognition attendance Mohali,payroll software for IT companies Mohali
"
        />
        <link
          rel="canonical"
          href="https://www.waggex.com/best-payroll-software-in-mohali"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      </Helmet>
      <section className="relative overflow-hidden py-10 px-6 bg-[#D1DFEA]">
        <div className="relative z-10 max-w-6xl mx-auto text-center mt-8 mb-16">
          <h1 className="text-xl sm:text-3xl font-roboto font-bold text-[#10324F] leading-tight max-w-2xl mx-auto">
            Payroll Software For Mohali
          </h1>

          <p className="mt-5 text-sm sm:text-base lg:text-lg text-[#10324F] leading-relaxed max-w-4xl mx-auto">
            Waggex simplifies payroll with a platform designed for local
            employers. Easily manage employee salaries, attendance, leave,
            payslips, and statutory compliance from one dashboard. Whether you
            have a growing team or multiple offices, Waggex helps streamline
            payroll with accuracy and confidence
          </p>

          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() =>
                (window.location.href = "https://app.waggex.com/signup")
              }
              className="bg-[#17324D] text-white px-8 py-3 rounded-xl font-medium shadow-md hover:bg-[#10263B] transition-all w-full sm:w-auto"
            >
              Try Free for 5 Employees
            </button>

            <button
              onClick={() => (window.location.href = "/contact-us")}
              className="border border-[#17324D] text-[#17324D] px-8 py-3 rounded-xl font-medium hover:bg-[#17324D] hover:text-white transition-all w-full sm:w-auto"
            >
              Book Free Demo
            </button>
          </div>

          <div className="hidden lg:block">
            <div className="-mt-10 flex justify-center aspect-1440/226">
              <img
                src={HeadImageAppMobile}
                width={1152}
                height={181}
                fetchPriority="high"
                alt="Waggex payroll software Mohali automated salary processing and attendance management for businesses and SMEs"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Simplify Payroll Management for Your Workforce
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base leading-relaxed">
              From payroll processing and attendance tracking to leave
              management and employee records, simplify everyday HR tasks
              through one platform that helps reduce manual work, improve
              accuracy, and support business growth
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated Payroll Processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift Management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-Based Salary Calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>PDF Payslip Generation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Self-Service App</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Leave Management</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Face Recognition Attendance</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Automate Payroll with Speed and Accuracy
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Manual payroll processing can lead to salary errors, delayed
              payouts, and time-consuming HR work. Automate salary calculations,
              attendance, overtime, leave deductions, and payroll workflows to
              process salaries faster while improving accuracy and reducing
              administrative effort
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated payroll calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee salary reports</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based payroll processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payroll history and records</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Overtime and shift salary management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee payroll notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payslip generation in PDF format</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-3xl mx-auto leading-loose">
            Employees receive instant payslip notifications and can securely
            view or download their payslips anytime through the Employee App,
            reducing routine payroll-related HR requests
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Experience AI-Powered Attendance Management
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Managing attendance across multiple office teams, field staff,
              remote employees, and shift workers can be challenging. AI face
              recognition, GPS attendance, geo-fencing, and mobile check-ins
              help capture accurate attendance while reducing manual errors and
              improving payroll accuracy
            </p>
          </div>
          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift-Based Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mobile Attendance Marking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Geofencing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Attendance Reports</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>FaceLens AI Face Recognition Attendance</span>
              </div>
            </div>
          </div>
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center">
            Attendance records are sync directly with payroll, helping HR teams
            process salaries automatically and accurately while reducing manual
            work and attendance disputes
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Manage Leave & Shifts Without the Manual Work
            </h2>

            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Manage leave requests, shift schedules, and employee availability
              through automated approval workflows and real-time notifications.
              Reduce manual coordination, improve workforce planning, and keep
              daily operations running smoothly
            </p>
          </div>

          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Yearly leave allocation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave approval workflow</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave balance tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-time leave notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based leave management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift management</span>
              </div>
            </div>{" "}
          </div>
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-2xl mx-auto leading-loose">
            Employees can track the status of their leave requests in real time,
            while managers review and approve requests from one centralized
            platform
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Give Employees More Control. Save HR Time
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Employees can mark attendance directly through the app and apply
              for leave, access payslips, view work schedules, and stay updated
              through one mobile app. Self-service access reduces HR dependency,
              speeds up everyday tasks, and creates a better employee experience
            </p>
            <p className="mt-4 text-[#10324F] text-lg">Employee Can:</p>
          </div>
          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mark attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>View attendance history</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Apply for leave </span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Receive notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Download payslips</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Access employee records</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center">
            Routine HR requests are handled through one app, helping employees
            find what they need instantly while giving HR teams more time for
            strategic work
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              One platform for every business
            </h2>

            <p className="mt-4 text-[#10324F] text-lg">
              Designed for Businesses Ready to Scale:
            </p>
          </div>

          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Startups</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Factories</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>SMEs</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Service Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>IT Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Field Workforce Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Retail Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Agencies & Consultancies</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Suspense fallback={null}>
        <Whywaggexcommonchoice
          heading="Built for Businesses Ready to Grow"
          description="As your workforce grows, payroll and HR become more complex. Bring payroll, attendance, leave management, and employee records together in one platform that helps reduce administrative effort, improve accuracy, and keep everyday operations running smoothly"
          paragraph=""
        />
        <LookingforPayroll
          heading="Start Free or Book a Personalized Demo"
          subHeading="Try Waggex Free No Long-Term Commitment"
          description="Experience faster payroll processing, accurate attendance tracking, and simplified HR management through one easy-to-use platform"
          features={[
            "AI Attendance Management",
            "Payroll Automation",
            "Employee Self-Service App",
            "GPS & Face Recognition Attendance",
            "Attendance-Based Payroll",
            "Real-Time Notifications",
          ]}
          buttonText="Book Free Demo"
        />
        <HomeFaq
          faq1={faq1}
          faq2={faq2}
          subtitle="Everything you need to know about Waggex payroll software in India"
        />
        {/*  <AppDownloadCard /> */}
        <PayrollBanner
          heading="See How Easy Payroll Can Be"
          description="Experience payroll software designed to save time, reduce manual work, and improve accuracy—with no obligation to continue"
          buttonText="View HRMS Software"
          buttonLink="https://waggex.com/"
        />
        <AppDownloadCard />
        <ModernizeHR />
      </Suspense>
    </>
  );
};

export default Mohali;
